module.exports = __webpack_public_path__ + "static/img/2.73b7f18.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/eng/2.png
// module id = W+Kn
// module chunks = 0